import Reveal from '@/components/base/Reveal';
import { feedPosts, hotRanking } from '@/mocks/home';

export default function LatestFeed() {
  return (
    <section id="latest" className="bg-background-100 border-y border-background-200">
      <div className="max-w-screen-xl mx-auto px-4 md:px-6 py-14 md:py-20">
        <Reveal>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
            <div>
              <span className="inline-flex items-center gap-2 text-primary-600 text-xs md:text-sm font-bold tracking-wide">
                <i className="ri-newspaper-line"></i>
                最新更新
              </span>
              <h2 className="mt-3 font-heading font-black text-2xl md:text-4xl text-foreground-950 tracking-tight">
                黑料福利最新料 · 一条不漏
              </h2>
            </div>
            <span className="inline-flex items-center gap-2 text-xs md:text-sm text-foreground-500 shrink-0">
              <i className="ri-history-line"></i>
              按更新时间由近到远排列 · 共 {feedPosts.length} 条
            </span>
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8">
          <div className="lg:col-span-8">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {feedPosts.map((post, index) => (
                <Reveal key={post.title} delay={(index % 4) * 70}>
                  <article className="group h-full flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-primary-300 transition-colors cursor-pointer">
                    <div className="relative w-full h-40 overflow-hidden">
                      <img
                        src={post.image}
                        alt={`黑料福利最新：${post.title}`}
                        title={`黑料福利 ${post.tag} 更新`}
                        className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                      />
                      <span className="absolute top-2.5 left-2.5 px-2 py-0.5 rounded-full bg-background-50/95 text-primary-700 text-[11px] font-bold">
                        {post.tag}
                      </span>
                    </div>
                    <div className="flex-1 flex flex-col p-4">
                      <h3 className="font-heading font-bold text-sm md:text-base text-foreground-950 leading-snug group-hover:text-primary-600 transition-colors line-clamp-2">
                        {post.title}
                      </h3>
                      <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                        {post.excerpt}
                      </p>
                      <div className="mt-3 pt-3 flex items-center justify-between border-t border-background-200 text-[11px] md:text-xs text-foreground-500">
                        <span className="inline-flex items-center gap-3">
                          <span className="inline-flex items-center gap-1">
                            <i className="ri-chat-1-line"></i>
                            {post.comments}
                          </span>
                          <span className="inline-flex items-center gap-1 text-accent-700 font-medium">
                            <i className="ri-fire-line"></i>
                            {post.heat}
                          </span>
                        </span>
                        <span className="whitespace-nowrap">{post.time}</span>
                      </div>
                    </div>
                  </article>
                </Reveal>
              ))}
            </div>

            <button
              type="button"
              className="cursor-pointer mt-6 w-full whitespace-nowrap inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-md bg-background-50 border border-background-300 text-foreground-900 text-sm font-medium hover:bg-primary-50 hover:border-primary-300 hover:text-primary-600 transition-colors"
            >
              <i className="ri-arrow-down-double-line w-5 h-5 flex items-center justify-center"></i>
              加载更多今日更新
            </button>
          </div>

          <aside className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
                <div className="flex items-center justify-between px-5 py-4 border-b border-background-200">
                  <h3 className="font-heading font-black text-lg text-foreground-950 inline-flex items-center gap-2">
                    <i className="ri-fire-fill text-primary-500"></i>
                    今日热榜
                  </h3>
                  <span className="text-xs text-foreground-500">每小时刷新</span>
                </div>

                <ol className="divide-y divide-background-200">
                  {hotRanking.map((item) => (
                    <li key={item.rank}>
                      <a
                        href="#topics"
                        className="cursor-pointer flex items-start gap-3 px-5 py-3.5 hover:bg-primary-50 transition-colors"
                      >
                        <span
                          className={`shrink-0 w-6 h-6 rounded-md flex items-center justify-center text-xs font-black ${
                            item.rank <= 3
                              ? 'bg-primary-500 text-background-50'
                              : 'bg-background-200 text-foreground-600'
                          }`}
                        >
                          {item.rank}
                        </span>
                        <span className="flex-1 min-w-0">
                          <span className="block text-sm font-medium text-foreground-900 leading-snug line-clamp-2 hover:text-primary-600 transition-colors">
                            {item.title}
                          </span>
                          <span className="mt-1.5 flex items-center gap-3 text-xs text-foreground-500">
                            <span className="inline-flex items-center gap-1 text-accent-700 font-medium">
                              <i className="ri-fire-line"></i>
                              {item.heat}
                            </span>
                            <span>{item.tag}</span>
                          </span>
                        </span>
                      </a>
                    </li>
                  ))}
                </ol>
              </div>

              <div className="mt-5 bg-secondary-50 border border-secondary-200 rounded-lg p-5">
                <span className="w-10 h-10 rounded-md bg-secondary-500 text-background-50 flex items-center justify-center">
                  <i className="ri-notification-3-line text-xl"></i>
                </span>
                <h3 className="mt-3.5 font-heading font-bold text-base text-foreground-950">订阅每日更新提醒</h3>
                <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                  黑料福利每日更新一次汇总，开启提醒后当天有新料会第一时间通知你。
                </p>
                <button
                  type="button"
                  className="cursor-pointer mt-4 w-full whitespace-nowrap inline-flex items-center justify-center gap-2 px-4 py-3 rounded-md bg-secondary-500 text-background-50 text-sm font-medium hover:bg-secondary-600 transition-colors"
                >
                  <i className="ri-checkbox-circle-line w-4 h-4 flex items-center justify-center"></i>
                  开启提醒
                </button>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}